import { AttachMoney, DeleteForever, Edit, MonetizationOn, Newspaper } from '@mui/icons-material'
import { Avatar, Button, ButtonGroup, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material'
import { green, grey, purple } from '@mui/material/colors'
import React, { FunctionComponent } from 'react'

import { numberWithCommasPlaces } from '../../../base/components/MyInputs/NumberInput'
import { ResponsiveTableContainer } from '../../../base/components/Table/ResponsiveTableContainer.tsx'
import { MonedaProps } from '../../../interfaces/monedaPrecio.ts'

interface OwnProps {
  moneda: MonedaProps | null
  monedaLocal: MonedaProps | null
  onRegistro: (value?: boolean) => void
  onEliminar: (value?: MonedaProps) => void
  onActualizar: (value?: MonedaProps) => void
  subTitle: string
  color?: string
  editable?: boolean
}

type Props = OwnProps

/**
 * Articulo moneda card
 * @param props
 * @constructor
 */
const ArticuloMonedaCard: FunctionComponent<Props> = (props) => {
  const { moneda, monedaLocal, subTitle, editable, onRegistro, onEliminar, onActualizar } = props

  if (!moneda || !monedaLocal)
    return (
      <Grid container spacing={1}>
        <Grid size={12}>
          <Card variant={'elevation'} elevation={2}>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: grey[300], width: 50, height: 50 }} aria-label="recipe">
                  <AttachMoney fontSize={'large'} />
                </Avatar>
              }
              title={
                <Typography fontSize={'larger'} color={'warning'}>
                  SIN DEFINIR
                </Typography>
              }
              subheader={<Typography color={'warning'}>{subTitle.toUpperCase()}</Typography>}
            />
            <CardContent sx={{ mt: -2.5, pb: '16px !important' }}>
              <Grid container spacing={2} sx={{ p: 0, mt: 1 }}>
                <Grid size={12}>
                  <ResponsiveTableContainer>
                    <table className={'table-dense'}>
                      <tbody>
                        <tr>
                          <td style={{ width: '70%' }}>Tipo Cambio</td>
                          <td style={{ textAlign: 'right' }}>
                            <strong>--</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Tipo Cambio Compra</td>
                          <td style={{ textAlign: 'right' }}>
                            <strong>--</strong>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <ButtonGroup
                              variant="outlined"
                              aria-label="Opciones de moneda"
                              color={'success'}
                              size={'small'}
                            >
                              <Button startIcon={<Newspaper />} onClick={() => onRegistro(true)}>
                                Registrar {subTitle}
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ResponsiveTableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    )

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Card variant={'elevation'} elevation={2}>
          <CardHeader
            avatar={
              <Avatar
                sx={{
                  bgcolor: moneda._id === monedaLocal._id ? green[500] : purple[500],
                  width: 50,
                  height: 50,
                }}
                aria-label="recipe"
              >
                <MonetizationOn fontSize={'large'} />
              </Avatar>
            }
            title={
              <>
                <Typography fontSize={'larger'} display={'inline'}>
                  <strong>
                    {moneda.sigla} - {moneda.descripcion}
                  </strong>
                </Typography>
              </>
            }
            subheader={subTitle}
          />
          <CardContent sx={{ mt: -2.5, pb: '16px !important' }}>
            <Grid container spacing={2} sx={{ p: 0 }}>
              <Grid size={12}>
                <ResponsiveTableContainer>
                  <table className={'table-dense'}>
                    <tbody>
                      <tr>
                        <td style={{ width: '70%' }}>Tipo Cambio</td>
                        <td style={{ textAlign: 'right' }}>
                          <Typography variant={'subtitle2'} fontSize={'larger'} display={'inline'}>
                            {numberWithCommasPlaces(moneda.tipoCambio)}
                          </Typography>
                          <Typography fontSize={'smaller'} display={'inline'} sx={{ ml: 1 }}>
                            {monedaLocal.sigla}
                          </Typography>
                        </td>
                      </tr>
                      <tr>
                        <td>Tipo Cambio Compra</td>
                        <td style={{ textAlign: 'right' }}>
                          <Typography variant={'subtitle2'} fontSize={'larger'} display={'inline'}>
                            {numberWithCommasPlaces(moneda.tipoCambioCompra || 0)}
                          </Typography>
                          <Typography fontSize={'smaller'} display={'inline'} sx={{ ml: 1 }}>
                            {monedaLocal.sigla}
                          </Typography>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <ButtonGroup
                            variant="outlined"
                            aria-label="Loading button group"
                            disabled={!editable}
                            size={'small'}
                          >
                            <Button
                              color={'error'}
                              startIcon={<DeleteForever />}
                              onClick={() => onEliminar(moneda)}
                            >
                              Eliminar
                            </Button>
                            <Button startIcon={<Edit />} onClick={() => onActualizar(moneda)}>
                              Modificar T.C.
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ResponsiveTableContainer>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default ArticuloMonedaCard
